import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

/**
 * TechProOne wordmark. Renders an inline SVG icon next to the brand
 * name so the sidebar doesn't depend on an external asset and the
 * colors stay on-brand regardless of theme.
 *
 *   <Logo expanded /> — icon + wordmark
 *   <Logo />         — icon only (mini sidebar)
 */
export default function Logo({ expanded = true }) {
  return (
    <Stack direction='row' alignItems='center' spacing='8px'>
      <Box
        component='svg'
        viewBox='0 0 40 40'
        sx={{ width: 32, height: 32, flexShrink: 0 }}
      >
        <defs>
          <linearGradient id='tpo-mark' x1='0' y1='0' x2='1' y2='1'>
            <stop offset='0%' stopColor='#7C3AED' />
            <stop offset='100%' stopColor='#4F46E5' />
          </linearGradient>
        </defs>
        <rect width='40' height='40' rx='10' fill='url(#tpo-mark)' />
        <rect x='9' y='11' width='22' height='4' rx='2' fill='#fff' />
        <rect x='15' y='15' width='10' height='15' rx='2' fill='#fff' />
        <circle cx='29' cy='13' r='2.5' fill='#fff' />
      </Box>
      {expanded && (
        <Typography
          variant='subtitle1'
          fontWeight='800'
          letterSpacing='-0.3px'
          sx={{ background: 'linear-gradient(90deg, #4F46E5, #7C3AED)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}
          noWrap
        >
          TechProOne
        </Typography>
      )}
    </Stack>
  );
}
